import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { NominalShipping } from '../../../../../typings'
import { ReviewProps } from './constants'
import { messages } from './messages'

export function NominalShippingRecap(props: ReviewProps) {
  const { config } = props
  const { formatCurrency } = useNumbers()

  if (!config.benefit || !config.scope) return null

  const { benefit, scope } = config

  return (
    <FormattedMessage
      {...messages.nominalShipping}
      values={{
        b: (content) => <Text variant="action1">{content}</Text>,
        discount: formatCurrency((benefit as NominalShipping).value),
        applyTo: scope.applyTo,
      }}
    />
  )
}
